import {isNil} from 'lodash';
import {useState} from 'react';
import {useMessages} from '@epic-mw/i18n';
import {getMessage} from '@/lib/utils/i18n.utils';
import {AlertBanner} from '@eds-web/react';
import {useAccountTotalBalance, useGiftCardRedeemedAmount} from '@/hooks';
import {css} from '@panda/css';

export const RedeemedBannerTrigger = () => {
	const messages = useMessages();
	const accountBalance = useAccountTotalBalance();
	const redeemedAmountMaybe = useGiftCardRedeemedAmount();
	const [dismissed, setDismissed] = useState(false);
	const hide = isNil(redeemedAmountMaybe) || dismissed;

	if (hide) {
		return null;
	}

	return (
		<AlertBanner
			isDismissable={true}
			closeLabel={messages['epic.app.close']}
			onClose={() => setDismissed(true)}
			status="success"
			className={css({
				smDown: {
					justifyContent: 'left !important',
					'& > svg': {display: 'none'},
					paddingX: '1rem !important'
				}
			})}
			message={
				<>
					{/* Desktop message */}
					<p
						className={css({
							margin: 0,
							display: 'block',
							smDown: {display: 'none'}
						})}>
						<span>
							{getMessage(messages, 'epic.app.addFunds.alert.success', [
								<strong>{redeemedAmountMaybe}</strong>
							])}
						</span>
					</p>
					{/* Mobile message */}
					<p
						className={css({
							margin: 0,
							display: 'none',
							smDown: {display: 'block'}
						})}>
						<span>
							{getMessage(messages, 'epic.app.addFunds.alert.added', [
								<strong>{redeemedAmountMaybe}</strong>
							])}
						</span>
						<br />
						<span>
							{getMessage(messages, 'epic.app.addFunds.alert.balanceNow', [
								<strong>{accountBalance.data?.formattedBalance}</strong>
							])}
						</span>
					</p>
				</>
			}
		/>
	);
};
